import upgradeOptions from './upgrade-options';
import domainPurchase from './domain-purchase';
import paymentURL from './payment-url';

export default {
  upgradeOptions,
  domainPurchase,
  paymentURL,
};
